import type { ResolvedTheme, ThemeAdapter } from '@splitfiesta/core';

/**
 * Web ThemeAdapter implementation.
 *
 * Reads the system color scheme from `window.matchMedia` and applies the
 * resolved theme by toggling the `dark` class on `<html>` (Tailwind's
 * dark-mode strategy).
 */
export const webThemeAdapter: ThemeAdapter = {
  getSystemTheme(): ResolvedTheme {
    try {
      return window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
    } catch {
      return 'light';
    }
  },

  subscribeSystemTheme(listener) {
    try {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const handler = (e: MediaQueryListEvent) => {
        listener(e.matches ? 'dark' : 'light');
      };
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    } catch {
      return () => {};
    }
  },

  applyTheme(theme) {
    try {
      if (theme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    } catch {
      /* SSR / no-DOM environment */
    }
  },
};
